import { SearchOutlined } from '@ant-design/icons';
import { FormHandler } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { GhostCollapse } from '@framework/ui';
import { AnyObject, yup } from '@framework/validation';
import { Button, Divider, Space } from 'antd';
import React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';

export interface IFilterPanelProps<T extends AnyObject> {
  open?: boolean;
  children?: React.ReactNode;
  schema: yup.ObjectSchema<T>;
  searchValues?: T;
  onSearch: (values: T | null) => void;
}
/**
 * @deprecated Usare FrontFilterPanel
 */
export function FilterPanel<T extends AnyObject>(props: IFilterPanelProps<T>) {
  const { open = false, children, onSearch, schema, searchValues } = props;
  const { t } = useTranslation();
  const isMobile = useBreakpoint(down('md'));

  return (
    <FormHandler
      schema={schema as any}
      initialValues={searchValues}
      onReset={() => onSearch(null)}
      hideVisualFeedback
      onSubmit={async rawValues => {
        try {
          const values = (await schema.validate(rawValues)) as T;
          onSearch(values);
        } catch (e) {
          console.error(`[Errore] Errore nella ricerca`, e);
        }
      }}
    >
      <GhostCollapse
        opened={open}
        button={
          <Space direction={!isMobile ? 'vertical' : undefined}>
            <Button block htmlType="reset">
              {t('collapse.filter-panel.clear', 'Pulisci')}
            </Button>
            <Button
              block
              type="primary"
              htmlType="submit"
              icon={<SearchOutlined aria-hidden />}
            >
              {t('collapse.filter-panel.search', 'Cerca')}
            </Button>
          </Space>
        }
      >
        {children}
      </GhostCollapse>
      {open && <Divider style={{ margin: 0 }} />}
    </FormHandler>
  );
}
